import React from 'react';

/**
 * Prozent-Badge mit Farbrampe: ≥80 grün, ≥60 gelb, ≥40 orange, sonst grau.
 * `incomplete` (kein Profil) wird als "—" dargestellt.
 */
export function MatchScoreBadge({ score, incomplete = false, size = 'md' }: {
  score: number;
  incomplete?: boolean;
  size?: 'sm' | 'md';
}) {
  const colors = incomplete
    ? { bg: 'rgba(102,112,133,0.12)', fg: '#667085' }
    : score >= 80 ? { bg: 'rgba(18,183,106,0.14)', fg: '#027a48' }
    : score >= 60 ? { bg: 'rgba(247,144,9,0.14)', fg: '#b54708' }
    : score >= 40 ? { bg: 'rgba(240,68,56,0.10)', fg: '#c4320a' }
    : { bg: 'rgba(102,112,133,0.12)', fg: '#667085' };

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      background: colors.bg, color: colors.fg,
      borderRadius: 9999,
      padding: size === 'sm' ? '1px 8px' : '3px 10px',
      fontSize: size === 'sm' ? 11 : 12.5,
      fontWeight: 700, fontFamily: 'Outfit, sans-serif',
      minWidth: size === 'sm' ? 38 : 46,
    }}>
      {incomplete ? '—' : `${score}%`}
    </span>
  );
}
